module.exports = __webpack_public_path__ + "img/cancun-bay-room-3.a80b4071.jpg";